import request from '@shared/utils/request'

/** 查询区域列表gis系统 */
export function getAreaScopeTreeList(data) {
  return request({
    url: '/gis-area-scope/treeList',
    method: 'post',
    data
  })
}
/**查询gis系统区域详情 */
export function getAreaScopeDetail(params) {
  return request({
    url: '/gis-area-scope/get',
    method: 'get',
    params
  })
}

/** 物联网区域详情 */
export function getIotScopeDetail() {
  return request({
    url: '/iot-config/get',
    method: 'get'
  })
}

/**内涝系统区域列表 */

export function getWaterLoggingScope(data) {
  return request({
    url: '/emergency-monitor-area/treeList',
    method: 'post',
    data
  })
}

/**内涝系统区域详情 */
export function getWaterLoggingScopeDetail(params) {
  return request({
    url: '/emergency-monitor-area/get',
    method: 'get',
    params
  })
}

/**水环境系统区域列表 */

export function getEnvironmentScope(data) {
  return request({
    url: '/env-water-monitor-area/treeList',
    method: 'post',
    data
  })
}

/**水环境系统区域详情 */
export function getEnvironmentScopeDetail(params) {
  return request({
    url: '/env-water-monitor-area/get',
    method: 'get',
    params
  })
}
/**泵站系统区域列表 */

export function getPdScope(data) {
  return request({
    url: '/pd-area/treeList',
    method: 'post',
    data
  })
}

/**泵站系统区域详情 */
export function getPdScopeDetail(params) {
  return request({
    url: '/pd-area/get',
    method: 'get',
    params
  })
}
